import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConsentGateService } from '../services/consent-gate.service';

// Runs on entry to the app shell; redirects to the full-page consent interstitial
// when the user must (re-)consent. Lifecycle focus/visibility hooks cover mid-session.
export const ConsentGuard: CanActivateFn = () => {
  return inject(ConsentGateService).checkAndGate();
};
